import { MasterConfigs } from "../../../interfaces/entity";
import MasterComponent from "../../../components/Forms";
import moment from "moment";

const Organizations = () => {
    const config: MasterConfigs = {
        api: () => '/organizations',
        title: 'Organizations',
        isActionTab: true,
        modalTitle: (action) => `${action}  Company`,
        searchKeys: ['companyName', 'companyWebsite', 'userName'],
        loadPagination: true,
        getColumns: () => {
            return [
                {
                    title: 'Company Name',
                    dataIndex: 'companyName',
                    key: 'companyName',
                },
                {
                    title: 'Company Website',
                    dataIndex: 'companyWebsite',
                    key: 'companyWebsite',
                    type: 'renderHtml',
                    width: 200,
                    ellipsis: true,
                    render: (text) => {
                        return text ? <a target='_blank' className="underline" href={text}>{text}</a> : 'NA';
                    }
                },
                {
                    title: 'client CRM',
                    dataIndex: 'clientCRMURL',
                    key: 'clientCRMURL',
                    type: 'renderHtml',
                    width: 150,
                    render: (text) => {
                        return text ? <a target='_blank' href={text}>{text}</a> : 'NA';
                    }
                },
                {
                    title: 'Email/UserName',
                    dataIndex: 'userName',
                    key: 'userName',
                    width: 150,
                    render: (text) => {
                        return text ? text : 'NA';
                    }
                },
                {
                    title: 'Added By',
                    dataIndex: 'addedBy',
                    key: 'addedBy',
                    width: 150,
                    render: (text) => {
                        return text ? [text.firstName, text.lastName].join(' ') : '';
                    }
                },
                {
                    title: 'Updated By',
                    dataIndex: 'updatedBy',
                    key: 'updatedBy',
                    width: 150,
                    render: (text) => {
                        return text ? [text.firstName, text.lastName].join(' ') : '';
                    }
                },
                {
                    title: 'Created At',
                    dataIndex: 'createdAt',
                    key: 'createdAt',
                    align: 'center',
                    width: 150,
                    render: (text) => {
                        return moment(text).format('lll');
                    }
                },
            ];
        },
        getFormColumns: () => {
            return [
                {
                    label: 'Company Name',
                    name: 'companyName',
                    type: 'text',
                    rules: [{ required: true, message: 'Please input Company Name!' }],
                },
                {
                    label: 'Company Website',
                    name: 'companyWebsite',
                    type: 'text',
                    rules: [{ required: true, message: 'Please input Company Website!' }],
                },
                {
                    label: 'Client CRM URL',
                    name: 'clientCRMURL',
                    type: 'text',
                },
                {
                    label: 'Email/UserName',
                    name: 'userName',
                    type: 'text',
                },
                {
                    label: 'Password',
                    name: 'password',
                    type: 'text',
                },
            ];
        },
        combo: [],
        getData: () => ({}),
        actions: [
            { actionType: 'Add', name: 'Add Organization' },
        ],
    }

    return (
        <MasterComponent config={config} />
    );
}

export default Organizations;